import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PrintIcon from "@mui/icons-material/Print";

// Visualizador de PDF embutido (modal), sem depender de abrir nova aba
// (evita bloqueador de popup). Renderiza o PDF num iframe = visualizador
// nativo do navegador, com botões de imprimir / abrir em nova aba / fechar.
const PdfViewer = ({ blobUrl, filename, loading, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  const openTab = () => {
    if (blobUrl) window.open(blobUrl, "_blank");
  };
  const print = () => {
    const f = document.getElementById("pdfviewer-frame");
    try {
      f.contentWindow.focus();
      f.contentWindow.print();
    } catch {
      if (blobUrl) window.open(blobUrl, "_blank");
    }
  };

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 13000,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6px 10px",
          color: "#fff",
          gap: 8,
        }}
      >
        <span
          style={{
            fontSize: "0.9rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {filename}
        </span>
        <div style={{ display: "flex", gap: 2, flexShrink: 0 }}>
          <IconButton onClick={print} disabled={!blobUrl} style={{ color: "#fff" }} title="Imprimir">
            <PrintIcon />
          </IconButton>
          <IconButton onClick={openTab} disabled={!blobUrl} style={{ color: "#fff" }} title="Abrir em nova aba">
            <OpenInNewIcon />
          </IconButton>
          <IconButton onClick={onClose} style={{ color: "#fff" }} title="Fechar (ESC)">
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      {loading || !blobUrl ? (
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            gap: 12,
          }}
        >
          <CircularProgress style={{ color: "#fff" }} />
          <span>Preparando documento…</span>
        </div>
      ) : (
        <iframe
          id="pdfviewer-frame"
          src={blobUrl}
          title="documento"
          style={{ flex: 1, border: 0, background: "#fff", width: "100%" }}
        />
      )}
    </div>,
    document.body
  );
};

export default PdfViewer;
